module.exports = __webpack_public_path__ + "static/media/bg-header-desktop.6e2f7196.svg";